import { configureStore } from '@reduxjs/toolkit'
import userSlice from './slices/userSlice'
import entryFormSlice from './slices/entryFormSlice'
import layoutSlice from './slices/layoutSlice'
import notificationsSlice from './slices/notificationsSlice'

export const store = configureStore({
  reducer: {
    user: userSlice,
    entryForm: entryFormSlice,
    layout: layoutSlice,
    notifications: notificationsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['notifications/addNotification'],
        ignoredPaths: ['notifications.confirmationResolver'],
      },
    }),
})